import { makeAutoObservable, runInAction } from 'mobx'
import { updateDesignV2Api } from 'shared/lib'
import { SingletonRequest } from 'shared/api/lib'
import { FeaturesFlagsApi } from 'entities/FeatureFlags/api/featuresFlags'
import { type UserSettingsStore } from 'entities/Settings'

export type IFeatureFlagsStore = FeatureFlagsStore

export class FeatureFlagsStore {
  loading = false

  groups_flow = false
  message_deduplication = false
  call_distribution = false
  allNumbersCalls = false
  show_new_design_only = false
  call_via_aircall = false
  inteliquent_calling = false
  hubspot_pin_list = false
  salesmsg_design_v2_salesforce = false
  salesmsg_design_v2_compliance_toll_free = false
  salesmsg_design_v2_compliance_calling = false
  salesmsg_design_v2_calendly_page = false
  webhook_setting = false
  aircall_new_api = false
  salesmsg_ai_agent_book_appointment_v2 = false
  salesmsg_compliance_ai_v2 = false
  uk_compliance = false
  zoho_integration = false
  airtable_integration = false
  hubspot_workflow_statistics = false
  salesmsg_design_v2_general_org_setting = false
  salesmsg_design_v2_email_to_sms_org_setting = false
  settings_inboxes_manage_inbox_calling_v2 = false
  search_results_page = false
  hide_duplicated_conversations_filters = false
  rcs_settings = false
  teams_flow = false
  workflows_v2_ai_agent = false
  saved_replies_v2 = false
  click_to_text = false
  billing_upgrade_v2 = false
  billing_overview_v2 = false
  hipaa_setting_toggle = false
  qualify = false
  v2_billing_overview_page = false
  send_as_contact_owner = false
  salesmsg_design_v2_clients = false
  smart_views = false
  chat_widget_setting_v2 = false
  url_shortener_design_v2 = false
  salesforce_agentforce = false
  unified_agent_enabled = false
  show_waiting_time = false
  surveys = false
  reviews = false
  call_flow_ivr_bh_enabled = false
  rcs_compliance_v2 = false
  system_health_dashboard = false

  constructor(private _userSettingsStore: UserSettingsStore) {
    makeAutoObservable(this)
  }

  private _fetchFeatureFlags = async () => {
    try {
      this.loading = true

      const { data: featureFlags } = await FeaturesFlagsApi.getFeatureFlags()

      runInAction(() => {
        this.groups_flow = featureFlags.groups_flow
        this.message_deduplication = featureFlags.message_deduplication
        this.call_distribution = featureFlags.call_distribution
        this.allNumbersCalls = featureFlags.allNumbersCalls
        this.show_new_design_only = featureFlags.show_new_design_only
        this.call_via_aircall = featureFlags.call_via_aircall
        this.inteliquent_calling = featureFlags.inteliquent_calling
        this.hubspot_pin_list = featureFlags.hubspot_pin_list
        this.salesmsg_design_v2_salesforce = featureFlags.salesmsg_design_v2_salesforce
        this.webhook_setting = featureFlags.webhook_setting
        this.salesmsg_design_v2_compliance_toll_free =
          featureFlags.salesmsg_design_v2_compliance_toll_free
        this.salesmsg_design_v2_compliance_calling =
          featureFlags.salesmsg_design_v2_compliance_calling
        this.salesmsg_design_v2_calendly_page = featureFlags.salesmsg_design_v2_calendly_page
        this.aircall_new_api = featureFlags.aircall_new_api
        this.salesmsg_ai_agent_book_appointment_v2 =
          featureFlags.salesmsg_ai_agent_book_appointment_v2
        this.salesmsg_compliance_ai_v2 = featureFlags.salesmsg_compliance_ai_v2
        this.uk_compliance = featureFlags.uk_compliance
        this.zoho_integration = featureFlags.zoho_integration
        this.airtable_integration = featureFlags.airtable_integration
        this.hubspot_workflow_statistics = featureFlags.hubspot_workflow_statistics
        this.salesmsg_design_v2_general_org_setting = featureFlags.general_org_setting
        this.salesmsg_design_v2_email_to_sms_org_setting = featureFlags.email_to_sms_org_setting
        this.search_results_page = featureFlags.search_results_page
        this.hide_duplicated_conversations_filters =
          featureFlags.hide_duplicated_conversations_filters
        this.rcs_settings = featureFlags.rcs_settings
        this.teams_flow = featureFlags.teams_flow
        this.settings_inboxes_manage_inbox_calling_v2 =
          featureFlags.settings_inboxes_manage_inbox_calling_v2
        this.workflows_v2_ai_agent = featureFlags.workflows_v2_ai_agent
        this.saved_replies_v2 = featureFlags.saved_replies_v2
        this.click_to_text = featureFlags.click_to_text
        this.billing_overview_v2 = featureFlags.billing_overview_v2
        this.billing_upgrade_v2 = featureFlags.billing_upgrade_v2
        this.hipaa_setting_toggle = featureFlags.hipaa_setting_toggle
        this.qualify = featureFlags.qualify
        this.v2_billing_overview_page = featureFlags.v2_billing_overview_page
        this.send_as_contact_owner = featureFlags.send_as_contact_owner
        this.salesmsg_design_v2_clients = featureFlags.salesmsg_design_v2_clients
        this.smart_views = featureFlags.smart_views
        this.chat_widget_setting_v2 = featureFlags.chat_widget_setting_v2
        this.url_shortener_design_v2 = featureFlags.url_shortener_design_v2
        this.salesforce_agentforce = featureFlags.salesforce_agentforce
        this.unified_agent_enabled = featureFlags.unified_agent_enabled
        this.show_waiting_time = featureFlags.show_waiting_time
        this.surveys = featureFlags.surveys
        this.reviews = featureFlags.reviews
        this.call_flow_ivr_bh_enabled = featureFlags.call_flow_ivr_bh_enabled
        this.rcs_compliance_v2 = featureFlags.rcs_compliance_v2
        this.system_health_dashboard = featureFlags.system_health_dashboard
      })
    } catch (e) {
      console.log(e)
    } finally {
      runInAction(() => {
        this.loading = false
      })

      updateDesignV2Api({
        is_enable_new_design:
          this.show_new_design_only ?? this._userSettingsStore.isSalesmsgDesignV2,
        salesmsg_design_v2_salesforce: this.salesmsg_design_v2_salesforce,
        salesmsg_design_v2_compliance_toll_free: this.salesmsg_design_v2_compliance_toll_free,
        salesmsg_design_v2_compliance_calling: this.salesmsg_design_v2_compliance_calling,
        webhook_setting: this.webhook_setting,
        salesmsg_design_v2_calendly_page: this.salesmsg_design_v2_calendly_page,
        salesmsg_design_v2_clients: this.salesmsg_design_v2_clients,
        chat_widget_setting_v2: this.chat_widget_setting_v2,
        url_shortener_design_v2: this.url_shortener_design_v2,
      })
    }
  }

  fetchFeatureFlags = new SingletonRequest(this._fetchFeatureFlags, { cache: true }).request

  get canManageRCS() {
    return this.rcs_settings
  }

  get savedRepliesV2() {
    return this.saved_replies_v2
  }

  get canManageClickToText() {
    return this.click_to_text
  }
}
